import MicrolinkBase from 'components/patterns/Microlink/Microlink'
import { withContainer } from 'helpers/hoc/with-container'

export const Microlink = withContainer(MicrolinkBase)
